import { IconButton } from '@c2fo/liquidity';
import { XmarkIcon, ExclamationCircleIcon, ExclamationTriangleIcon } from '@c2fo/liquidity/icons';
import { useErrorState, type FileDeliveryError } from '../../contexts';

const ErrorItem: React.FC<{ error: FileDeliveryError; onDismiss: (id: string) => void }> = ({ error, onDismiss }) => {
  const isWarning = error.type === 'warning';

  return (
    <div
      className={`flex items-center justify-between gap-3 px-4 py-3 rounded-md ${
        isWarning
          ? 'bg-yellow-50 border border-yellow-200 text-yellow-800'
          : 'bg-red-50 border border-red-200 text-red-800'
      }`}
    >
      <div className="flex items-center gap-3">
        {isWarning ? (
          <ExclamationTriangleIcon className="h-5 w-5 text-yellow-600 flex-shrink-0" />
        ) : (
          <ExclamationCircleIcon className="h-5 w-5 text-red-600 flex-shrink-0" />
        )}
        <span className="text-sm font-medium">{error.message}</span>
      </div>
      {error.dismissible && (
        <IconButton
          icon={XmarkIcon}
          name="Dismiss"
          variant="ancillary"
          size="sm"
          onClick={() => onDismiss(error.id)}
          className={isWarning ? 'text-yellow-600 hover:text-yellow-700' : 'text-red-600 hover:text-red-700'}
        />
      )}
    </div>
  );
};

export const ErrorBanner: React.FC = () => {
  const { errors, removeError } = useErrorState();

  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="px-4 py-2 space-y-2">
      {errors.map((error) => (
        <ErrorItem key={error.id} error={error} onDismiss={removeError} />
      ))}
    </div>
  );
};
